const initialState = {
    refreshResTable:'',
    searchResValue:[],
};
export const actionTypes = {
    REFRESH_RES_TABLE: "REFRESH_RES_TABLE",
    SEARCH_RES_TABLE:"SEARCH_RES_TABLE",
};

export const actions = {
    refresh_res_table: function (data) {
        return {
            type: actionTypes.REFRESH_RES_TABLE,
            data
        }
    },
    search_res_table: function (data) {
        return {
            type: actionTypes.SEARCH_RES_TABLE,
            data
        }
    }
};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.REFRESH_RES_TABLE:{
            return {...state,refreshResTable:action.data}
        }
        case actionTypes.SEARCH_RES_TABLE:{
            return {...state,searchResValue:action.data}
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/resReducer.js